<evc-modal [showCloseButton]="true"
           [showReduceButton]="false"
           [showBackdrop]="false"
           [height]="'275px'"
           [width]="'604px'"
           (closeModal)="close()">

  <span modal-title>{{ 'topMenuBar.legal' | translate }}</span>

  <div class="modal-container" modal-content>

    <div class="title-container">
        <evc-svg-icon [svgPath]="appIdentity.logo" class="icon" />
        <span class="title">{{ appIdentity.title }}</span>
    </div>

    <div class="legal-links">
      @if (isOnline) {
        <a href="{{privacyPolicyLink}}" target="_blank">{{ 'links.privacy_notice.text' | translate }}</a>
        <a href="{{cookieNoticeLink}}" target="_blank">{{ 'links.cookies.text' | translate }}</a>
      }
      <a class="dialog-link" (click)="gotoLicenseAgreement()">{{ 'appAboutDialog.termsOfService' | translate }}</a>
      <a class="dialog-link" (click)="gotoThirdPartyNotice()">{{ 'appAboutDialog.thirdPartyNoticeLabel' | translate }}</a>
    </div>

  </div>
</evc-modal>
